import './App.css';
import GenPage from './components/GenPage'

function App() {
  return (
    <div className="App">
      <GenPage/>
    </div>
  );
}

export default App;
